export default "__VITE_ASSET__CXN9d6z0__"